import { LEGAL_INFO } from './legal-info';
import { LegalLayout } from './LegalLayout';

export function ConfidentialitePage() {
  return (
    <LegalLayout
      title="Politique de confidentialité"
      subtitle="Informations sur le traitement des données à caractère personnel (RGPD)."
    >
      <section>
        <h2>1. Préambule</h2>
        <p>
          La présente politique a pour objet d'informer les utilisateurs du service «{' '}
          {LEGAL_INFO.productName} » des conditions dans lesquelles {LEGAL_INFO.companyName}{' '}
          collecte et traite leurs données à caractère personnel, conformément au Règlement (UE)
          2016/679 (« <strong>RGPD</strong> ») et à la loi Informatique et Libertés modifiée.
        </p>
      </section>

      <section>
        <h2>2. Responsable de traitement / Sous-traitant</h2>
        <p>Le rôle de {LEGAL_INFO.companyName} varie selon la finalité du traitement :</p>
        <ul>
          <li>
            <strong>Responsable de traitement</strong> pour les données qu'elle traite pour ses
            propres besoins (gestion des comptes administrateurs internes, facturation,
            authentification, journaux d'audit, prospection commerciale).
          </li>
          <li>
            <strong>Sous-traitant</strong>, au sens de l'article 28 du RGPD, pour les données que
            les Clients (organisations souscrivant un abonnement) traitent via le Service dans le
            cadre de leurs propres activités. Les modalités de cette sous-traitance sont précisées
            dans l'accord de traitement des données (DPA) signé avec chaque Client.
          </li>
        </ul>
        <p>
          Coordonnées du responsable de traitement / contact RGPD : {LEGAL_INFO.companyName},{' '}
          {LEGAL_INFO.legalAddress}, e-mail :{' '}
          <a href={`mailto:${LEGAL_INFO.dpoEmail}`}>{LEGAL_INFO.dpoEmail}</a>.
        </p>
      </section>

      <section>
        <h2>3. Données collectées et finalités</h2>
        <h3>3.1 Données de compte et d'authentification</h3>
        <ul>
          <li>
            <strong>Données :</strong> adresse e-mail, nom, prénom, rôle dans l'organisation, mot de
            passe (haché), secret 2FA (chiffré), date de dernière connexion.
          </li>
          <li>
            <strong>Finalité :</strong> permettre la création et la gestion du compte utilisateur,
            l'authentification, la sécurisation de l'accès.
          </li>
          <li>
            <strong>Base légale :</strong> exécution du contrat (art. 6.1.b RGPD).
          </li>
        </ul>
        <h3>3.2 Données d'usage du Service</h3>
        <ul>
          <li>
            <strong>Données :</strong> automatisations configurées, métadonnées des exécutions
            (statut, horodatages, durée, volume, déclencheur), incidents, statistiques d'usage,
            journal d'audit des actions sensibles.
          </li>
          <li>
            <strong>Finalité :</strong> fournir les fonctionnalités du Service, sécuriser
            l'application, assurer la traçabilité des actions sensibles.
          </li>
          <li>
            <strong>Base légale :</strong> exécution du contrat (art. 6.1.b RGPD) ; intérêt légitime
            à la sécurité du Service (art. 6.1.f RGPD).
          </li>
        </ul>
        <h3>3.3 Données techniques</h3>
        <ul>
          <li>
            <strong>Données :</strong> adresse IP, en-têtes HTTP, journaux techniques d'erreur.
          </li>
          <li>
            <strong>Finalité :</strong> bon fonctionnement et sécurité du Service, prévention de la
            fraude.
          </li>
          <li>
            <strong>Base légale :</strong> intérêt légitime (art. 6.1.f RGPD).
          </li>
        </ul>
        <h3>3.4 Données métier traitées via les automatisations</h3>
        <p>
          Les données métier que les Clients font transiter par le Service via leurs automatisations
          n8n sont traitées par {LEGAL_INFO.companyName} en qualité de sous-traitant, pour le seul
          compte du Client responsable de traitement. Elles sont stockées sous forme d'aperçus
          minimisés (« inputPreview ») et ne sont jamais utilisées à d'autres fins que la fourniture
          du Service.
        </p>
        <h3>3.5 Données de facturation et de prospection</h3>
        <ul>
          <li>
            <strong>Données :</strong> coordonnées du Client (raison sociale, SIRET, adresse,
            interlocuteurs), historique des factures.
          </li>
          <li>
            <strong>Finalité :</strong> gestion commerciale, facturation, recouvrement, obligations
            comptables.
          </li>
          <li>
            <strong>Base légale :</strong> exécution du contrat ; obligation légale comptable.
          </li>
        </ul>
      </section>

      <section>
        <h2>4. Durées de conservation</h2>
        <ul>
          <li>
            <strong>Comptes utilisateurs :</strong> pendant toute la durée de l'abonnement du
            Client, puis supprimés dans un délai maximum de trente (30) jours après la résiliation.
          </li>
          <li>
            <strong>Exécutions et incidents :</strong> selon la politique de rétention fixée par le
            Client (par défaut : douze (12) mois glissants), sauf exigence légale contraire.
          </li>
          <li>
            <strong>Journal d'audit des actions sensibles :</strong> trois (3) ans (sécurité du
            Service).
          </li>
          <li>
            <strong>Données de facturation :</strong> dix (10) ans après la fin de l'exercice
            comptable (obligation légale, art. L. 123-22 du Code de commerce).
          </li>
          <li>
            <strong>Données de prospection :</strong> trois (3) ans à compter du dernier contact
            émanant du prospect.
          </li>
        </ul>
      </section>

      <section>
        <h2>5. Destinataires des données</h2>
        <p>Les données sont accessibles aux destinataires suivants :</p>
        <ul>
          <li>
            les utilisateurs habilités au sein du Client responsable de traitement, selon les rôles
            définis dans le Service ;
          </li>
          <li>
            les personnels habilités de {LEGAL_INFO.companyName} intervenant pour la gestion ou le
            support du Service, soumis à une obligation de confidentialité ;
          </li>
          <li>
            les sous-traitants ultérieurs de {LEGAL_INFO.companyName} listés à l'article 7 ci-après
            ;
          </li>
          <li>
            le cas échéant, les autorités administratives ou judiciaires sur réquisition légale.
          </li>
        </ul>
        <p>Aucune donnée n'est cédée ou louée à des tiers à des fins commerciales.</p>
      </section>

      <section>
        <h2>6. Transferts hors UE</h2>
        <p>
          Les données sont hébergées au sein de l'Union européenne. Aucun transfert régulier vers
          des pays tiers n'est effectué. Si un transfert ponctuel devait s'avérer nécessaire (par
          exemple à l'occasion d'une intervention de support), il serait encadré par les garanties
          appropriées prévues aux articles 44 et suivants du RGPD (clauses contractuelles types,
          décision d'adéquation).
        </p>
      </section>

      <section>
        <h2>7. Sous-traitants ultérieurs</h2>
        <p>{LEGAL_INFO.companyName} a recours aux sous-traitants suivants :</p>
        <ul>
          <li>
            <strong>{LEGAL_INFO.hostingProvider}</strong> — hébergement de l'infrastructure
            applicative et de la base de données. Adresse : {LEGAL_INFO.hostingAddress}.
          </li>
          <li>
            <strong>n8n</strong> — moteur d'orchestration des automatisations, déployé sur la même
            infrastructure ou sur une instance dédiée selon la configuration.
          </li>
          <li>
            <strong>Prestataire SMTP</strong> — acheminement des e-mails transactionnels
            (invitations, réinitialisations de mot de passe, notifications). Le prestataire
            effectivement utilisé est précisé dans le contrat conclu avec chaque client.
          </li>
        </ul>
        <p>
          Toute modification substantielle de la liste des sous-traitants est notifiée aux Clients
          avec un préavis raisonnable, leur permettant de s'y opposer le cas échéant.
        </p>
      </section>

      <section>
        <h2>8. Sécurité</h2>
        <p>
          {LEGAL_INFO.companyName} met en œuvre des mesures techniques et organisationnelles
          appropriées :
        </p>
        <ul>
          <li>
            chiffrement des secrets sensibles au repos (AES-256-GCM) et des communications en
            transit (TLS) ;
          </li>
          <li>
            authentification forte des utilisateurs (mot de passe haché en argon2id, second facteur
            TOTP optionnel ou obligatoire selon les rôles) ;
          </li>
          <li>
            cloisonnement multi-tenant strict des données (filtrage applicatif et garde au niveau de
            la base de données) ;
          </li>
          <li>
            journalisation des actions sensibles (création, modification, suppression de droits,
            déclenchements, exports) ;
          </li>
          <li>sauvegardes régulières des bases de données, chiffrées au repos ;</li>
          <li>mises à jour de sécurité régulières et veille sur les dépendances logicielles.</li>
        </ul>
        <p>
          En cas de violation de données susceptible d'engendrer un risque pour les droits et
          libertés des personnes, une notification est effectuée à la CNIL dans un délai de 72
          heures, et les personnes concernées sont informées le cas échéant.
        </p>
      </section>

      <section>
        <h2>9. Vos droits</h2>
        <p>Conformément aux articles 15 à 22 du RGPD, vous disposez des droits suivants :</p>
        <ul>
          <li>
            <strong>Droit d'accès</strong> — obtenir confirmation que vos données sont traitées et
            en recevoir une copie.
          </li>
          <li>
            <strong>Droit de rectification</strong> — faire corriger des données inexactes ou
            incomplètes.
          </li>
          <li>
            <strong>Droit à l'effacement</strong> (« droit à l'oubli ») — obtenir l'effacement de
            vos données, sous réserve des obligations légales de conservation.
          </li>
          <li>
            <strong>Droit à la limitation</strong> — obtenir la suspension temporaire du traitement
            dans certains cas.
          </li>
          <li>
            <strong>Droit à la portabilité</strong> — recevoir vos données dans un format structuré
            et lisible par machine.
          </li>
          <li>
            <strong>Droit d'opposition</strong> — vous opposer au traitement pour des motifs tenant
            à votre situation particulière, et inconditionnellement en matière de prospection.
          </li>
          <li>
            <strong>Droit de retirer un consentement</strong> à tout moment lorsque le traitement
            repose sur un consentement.
          </li>
          <li>
            <strong>Droit de définir des directives</strong> relatives au sort de vos données après
            votre décès.
          </li>
        </ul>
        <p>
          Pour exercer ces droits, écrivez à{' '}
          <a href={`mailto:${LEGAL_INFO.dpoEmail}`}>{LEGAL_INFO.dpoEmail}</a>. Une preuve d'identité
          pourra vous être demandée en cas de doute raisonnable sur votre identité.
        </p>
        <p>
          Vous disposez par ailleurs du droit d'introduire une réclamation auprès de la Commission
          Nationale de l'Informatique et des Libertés (CNIL — 3 place de Fontenoy, 75007 Paris,{' '}
          <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">
            www.cnil.fr
          </a>
          ).
        </p>
      </section>

      <section>
        <h2>10. Cookies</h2>
        <p>
          Les modalités d'utilisation des cookies par le Service sont décrites dans la{' '}
          <a href="/legal/cookies">Politique de cookies</a>.
        </p>
      </section>

      <section>
        <h2>11. Évolution de la présente politique</h2>
        <p>
          La présente politique peut être modifiée pour tenir compte d'évolutions légales,
          jurisprudentielles, techniques ou fonctionnelles. Les utilisateurs sont informés des
          modifications substantielles par voie d'affichage dans le Service ou par e-mail.
        </p>
      </section>
    </LegalLayout>
  );
}
